import { FC, useState, useEffect } from 'react';

import { Box, Button } from '@mui/material';
import { Save } from '@mui/icons-material';

import ErrorMessage from '../../sharedModules/layout/ErrorMessage';
import TextInput from '../../sharedModules/form/components/TextInput';

interface InlineSaveFieldProps {
  value: string;
  onSave: (value: string) => Promise<void>;
  label?: string;
  rows?: number;
}

const InlineSaveField: FC<InlineSaveFieldProps> = ({ value, onSave, label = '', rows }) => {
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [localValue, setLocalValue] = useState<string>(value ?? '');

  useEffect(() => {
    setLocalValue(value ?? '');
  }, [value]);

  const handleSave = async () => {
    setLoading(true);
    try {
      await onSave(localValue);
      setErrorMessage('');
    } catch {
      setErrorMessage('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <ErrorMessage message={errorMessage} />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box sx={{ flex: 1 }}>
          <TextInput value={localValue} valueChanged={setLocalValue} label={label} rows={rows} shrinkLabel={!!label} />
        </Box>
        <Button
          variant="contained"
          size="small"
          onClick={handleSave}
          disabled={loading}
          sx={{ visibility: localValue !== value ? 'visible' : 'hidden', alignSelf: 'stretch' }}
        >
          <Save />
        </Button>
      </Box>
    </Box>
  );
};

export default InlineSaveField;
